import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastContainerDirective } from 'ngx-toastr';
import { checkPassword } from '@utils/validators';
import { Domain } from '@models/domain';
import { AtlasToastService } from '@services/atlas-toast.service';
import { DomainService } from '@services/domain.service';
import { ProfileService } from '@services/profile.service';

function matchingPasswords(matchTo: string): (AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    return !!control.parent && !!control.parent.value && control.value === control.parent.get(matchTo).value
      ? null
      : { notEquivalent: true };
  };
}

@Component({
  selector: 'wsb-login-component',
  templateUrl: './reset-profile.component.html',
  styleUrls: ['./reset-profile.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ResetProfileComponent implements OnInit {
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;
  resetForm: UntypedFormGroup = this.fb.group({
    newPassword: ['', [Validators.required, checkPassword()]],
    confirmNewPassword: this.fb.control('', [Validators.required, checkPassword(), matchingPasswords('newPassword')])
  });

  domain: Domain;
  show = false;
  gologin = false;
  loading = false;
  token = null;

  constructor(
    private profileService: ProfileService,
    private router: Router,
    private fb: UntypedFormBuilder,
    private domainService: DomainService,
    private atlasToastService: AtlasToastService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.domainService.getDomainState().subscribe(x => (this.domain = x));

    this.route.queryParams.subscribe(query => {
      this.token = query.activation_token;
      this.profileService.checkActivationToken(this.token).subscribe(
        res => {
          this.show = true;
        },
        () => {
          this.atlasToastService.error('reset_error', null, 60000000, this.toastContainer);
        }
      );
    });
  }

  goLogin() {
    this.router.navigate(['/login']);
  }

  submit(): Subscription {
    if (!this.resetForm.valid) {
      return;
    }
    this.loading = true;
    this.profileService.activate(this.resetForm.get('newPassword').value, this.token).subscribe(
      res => {
        this.gologin = true;
        this.atlasToastService.success('reset_ok', null, 60000000, this.toastContainer);
      },
      () => {
        this.loading = false;
        this.atlasToastService.error('reset_error', null, 60000000, this.toastContainer);
      }
    );
  }
}
